<template>
<div>
    <img :class="['annotation-el', 'annotation', 'annotation-image', selected ? 'selected': '', moveMode ? 'no-cursor': '']" @click="showControls"
      draggable="false" :src="'/static/' + name + '.svg'" :style="elStyle">
</div>

</template>

<script>
export default {
  name: 'annotation-image',

  props: [
    'index',
    'name',
    'width',
    'height',
    'rotation',
    'selected'
  ],

  data () {
    return {
      moveMode: false,
      resizeMode: false,
      rotateMode: false
    }
  },

  computed: {
    elStyle: function () {
      return 'width:' + this.width + 'px;height:' + this.height + 'px; transform: rotate(' + this.rotation + 'deg);'
    }
  },

  methods: {
    showControls () {
      if (this.moveMode || this.resizeMode) return
      const elPos = this.$el.getBoundingClientRect()
      this.$bus.emit('showAnnotationControls', {
        index: this.index,
        type: 'image',
        x: elPos.left,
        y: elPos.top + elPos.height
      })
    },

    keyPress (e) {
      if (!this.moveMode && !this.resizeMode && !this.rotateMode) return this.removeListeners()
      let keyCode = e.code
      if (this.moveMode || this.resizeMode) {
        if (keyCode === 'Enter' || keyCode === 'NumpadEnter' || keyCode === 'Escape') {
          this.stopElementUpdates()
        }
      } else if (this.rotateMode) {
        if (keyCode !== 'ArrowLeft' && keyCode !== 'ArrowRight') return
        let rotation = this.$store.getters.annotationRotation(this.index)
        if (keyCode === 'ArrowLeft') rotation -= 5
        else if (keyCode === 'ArrowRight') rotation += 5
        this.$store.commit('setAnnotationRotation', {index: this.index, amount: rotation})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .annotation-image {
    cursor: pointer;
    background: url(https://storage.googleapis.com/material-icons/external-assets/v4/icons/svg/ic_done_black_24px.svg) no-repeat center;
  }

  .annotation-image.no-cursor {
    cursor: default;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/annotations/AnnotationImage.vue